import { render, staticRenderFns } from "./anchor.vue?vue&type=template&id=c5bc6d92&scoped=true&"
import script from "./anchor.vue?vue&type=script&lang=js&"
export * from "./anchor.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/anchor/anchor.less?vue&type=style&index=0&id=c5bc6d92&lang=less&scoped=true&"
import style1 from "./anchor.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5bc6d92",
  null
  
)

component.options.__file = "anchor.vue"
export default component.exports